export const GROUP = {
  COMMON: "common",
  HEADER: "header",
  DIALER: "dialer",
  CALL: "call",
  SETTINGS: "settings",
  AUTH: "auth",
  ERRORS: "errors",
} as const;

export type GROUP = (typeof GROUP)[keyof typeof GROUP];

export const Language = {
  English: "english",
  Indonesian: "indonesian",
} as const;

export type Language = (typeof Language)[keyof typeof Language];

export interface TranslatedText {
  group: GROUP;
  placeholderText: string;
  english: string;
  indonesian: string;
}

export function createTranslatedText(
  group: GROUP,
  placeholderText: string,
  english: string,
  indonesian: string,
): TranslatedText {
  return {
    group,
    placeholderText,
    english,
    indonesian,
  };
}

export function getPlaceholderText(text: TranslatedText): string {
  return `${text.group}.${text.placeholderText}`;
}
